import { Button, Loading, Typography } from "@/components/atoms";
import { getErrorMessages } from "@/helpers/reduxHelpers";
import { useInviteUserMutation } from "@/redux/apis/userAccount/userAccountApi";
import { addToast } from "@/utils";
import { useUserAccountsContext } from "./contexts/userAccounts";

export const UserAccountsRestoreAccess = () => {
  const { setStep, selectedUserAccount: user } = useUserAccountsContext();
  const [restoreAccess, { isLoading }] = useInviteUserMutation();

  const description = `Are you sure you want to restore ${user?.name}'s access from RideMinder?`;

  const handleRemoveAccessClick = () => {
    if (!user) return;

    restoreAccess({ email: user.email, role: user.role })
      .unwrap()
      .then(() => {
        addToast("success", `Restored the Access of ${user?.name}`);
        setStep(undefined);
      })
      .catch((e) => getErrorMessages(e).forEach((message) => addToast("danger", message)));
  };

  return (
    <div className="relative">
      {isLoading && <Loading />}
      <div className="max-w-lg sm:flex sm:items-start ">
        <div className="mt-3 text-center sm:mt-0 sm:text-left">
          <Typography variant="title">Restore Access</Typography>
          <div className="mt-3">
            <Typography className="text-neutral-dark-gray">{description}</Typography>
          </div>
        </div>
      </div>
      <div className="mt-6 flex justify-end gap-4">
        <Button variant="secondary" onClick={() => setStep(undefined)} size="md">
          Cancel
        </Button>
        <Button variant="primary" onClick={handleRemoveAccessClick} size="md">
          Restore Access
        </Button>
      </div>
    </div>
  );
};
